import localforage from 'localforage'
import axios from 'axios'
import { setup } from 'axios-cache-adapter'

const CancelToken = axios.CancelToken;

// Create `localforage` instance
const forageStore = localforage.createInstance({
  // List of drivers used
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE,
    // memoryDriver._driver
  ],
  // Prefix all storage keys to prevent conflicts
  name: 'my-cache'
})

var ServiceAPI = function(options, setUserAuth) {
  options = options || {}

  setUserAuth = setUserAuth || function() {};

  var instance = setup({
    cache: {
      maxAge: 15 * 60 * 1000,
      exclude: {
        query: false
      },
      // Invalidate only when a specific option is passed through config
      store: forageStore,
      invalidate: async (config, request) => {
        if (request.ignoreCache) {
          // console.log("CLEAR CACHE",config.uuid)
          await config.store.removeItem(config.uuid)
        }
      }
    }
    // paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  })

  console.log("instance.cache",instance.cache)

  instance.defaults.baseURL = options.apiURL
  instance.defaults.headers.common.Accept = 'application/json'
  instance.defaults.withCredentials = false

  instance.interceptors.request.use(async (config) => {
    // console.log("REQ UUID",config.uuid)
    var originalRequest = config

    if (config.bypassInterceptor) {
      console.log('bypassed interceptor')
      return originalRequest
    }

    var token;
    var sub;
    var refreshToken;
    var tokenExpires;

    if(options.token) {
      token = options.token
    } else if(window.localStorage['userAuth']) {
      var userAuth = JSON.parse(window.localStorage['userAuth'])
      token = `${userAuth.TokenType} ${userAuth.IdToken}`
      sub = `${userAuth.UserSub}`
      refreshToken = `${userAuth.RefreshToken}`
      tokenExpires = userAuth.Expires
      // console.log("TOKENS",token,sub,refreshToken,tokenExpires)
    }

    if(!token) return originalRequest 

    //apply token
    originalRequest.headers['Authorization'] = token

    if(!refreshToken) return originalRequest

    var now = (new Date()).getTime() + (20 * 1000);

    if(now < tokenExpires) return originalRequest

    // window.alert("refresh token");

    const rawResponse = await fetch(`${options.apiURL}/token/refresh`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refreshToken,
        sub
      })
    });
    const content = await rawResponse.json();

    try {
      setUserAuth(content);
    } catch (error) {
      console.error(error);
    }

    if(window.localStorage['userAuth']) {
      let userAuthRef = JSON.parse(window.localStorage['userAuth'])
      token = `${userAuthRef.TokenType} ${userAuthRef.IdToken}`
    }

    if(!token) return originalRequest 

    //apply token
    originalRequest.headers['Authorization'] = token

    return originalRequest
  }, function(error) {
      return Promise.reject(error)
  })

  instance.clearAll = () => {forageStore.clear()}

  instance.CancelToken = CancelToken;

  return instance
}

export default ServiceAPI
